var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgC(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38.64 50.51",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.41 50.51-8.41-8.49v-33.79l8.41-8.23h21.91l8.18 8.23v11.5h-14.35v-6.63l-1.27-1.23h-7.17l-1.36 1.16v24.2l1.37 1.41h7.16l1.27-1.48v-6.11h14.49v10.97l-8.17 8.49z",
    className: "cjd-border",
    fill: "#525a6f"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m9.06 48.85-7.54-7.47v-32.5l7.54-7.36h20.61l7.45 7.36v9.34h-11.45v-5.77l-2.14-2.1h-8.47l-2.23 2.03v25.49l2.23 2.15h8.47l2.14-2.22v-5.37h11.59v8.95l-7.45 7.47z",
    className: "cjd-stroke",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m3.16 40.73v-31.21l6.55-6.55h19.31l6.56 6.55v7.06h-8.27v-4.78l-3.13-3.13h-9.76l-3.07 3.06v26.79l3.07 3.07h9.76l3.13-3.14v-4.49h8.41v6.77l-6.56 6.55h-19.45z",
    className: "cjd-fill",
    fill: "#8089a2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/c.1cc1b334d6367b35c5f0b228ddc54c5d.svg";
export { ForwardRef as ReactComponent };